// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2l7xG","info":"PatientInfo_info__3hjmr"};